import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import CloseIcon from "@mui/icons-material/Close";
import { Link, Typography } from "@mui/material";
import Avatar from "@mui/joy/Divider";
import { CheckoutMainCard } from "./CheckoutMainCard";
import { CheckoutCards } from "./CheckoutCards";

export default function Checkout_Dishes() {
  const [state1, setState1] = React.useState({
    right: false,
  });

  const toggleDrawer1 = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState1({ ...state1, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : {lg:"708px", md: "708px", sm: "auto", xs: "auto",}, paddingRight: {lg: "24px", md: "24px", sm: "24px", xs: "0px"} }}
      role="presentation"
      onClick={toggleDrawer1(anchor, false)}
      onKeyDown={toggleDrawer1(anchor, false)}
    >
      <Box sx={{ paddingLeft: "24px"}}>
        <Box >
          <List >
            <ListItem disablePadding >
              <ListItemButton sx={{ width: "20px", height: "76px", color: "#000000", fontSize: {lg: "24px", md: "24px", sm: "22px", xs: "18px"}, fontWeight: "600",  }}>
                <ListItemIcon>
                  <CloseIcon sx={{ color: "#E75C62" }} />
                  <ListItemText sx={{ paddingRight: {lg: "246px", md: "246px", sm: "246px", xs: "40px"}, color: "#000000", }} /> Your Basket
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>

        

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            // paddingLeft: "24px",
            paddingTop: "0px",
            marginTop: "0px",
          }}
        >
          <Box>
            <Typography
              sx={{ fontWeight: "400", fontSize: {lg: "18px", md: "18px", sm: "16px", xs: "16px"}, paddingRight: "12px" }}
            >
              Order from
            </Typography>
          </Box>

          <Box>
            <Link
              component="button"
              sx={{ fontWeight: "600", fontSize: {lg: "18px", md: "18px", sm: "16px", xs: "16px"} }}
            >
              Chef Juna Food
            </Link>
          </Box>
        </Box>
        <Box // ml="24px"
          sx={{ display: "flex", flexDirection: "row", marginTop: "24px", paddingLeft: "24px" }}><CheckoutMainCard/></Box>



        <Divider  />

        <Box>
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "24px", md: "24px", sm: "20px", xs: "18px" },
                fontWeight: "600",
                marginTop: "16px",
                // marginBottom: "16px",
              }}
            >
              Meal Courses
            </Typography>
            
            <Box sx={{paddingLeft: "24px", paddingBottom: "211.93px"}}><CheckoutCards/></Box>
          </Box>

          
        </Box>
      </Box>
      <Box>
            <Box>
            <Button
                variant="contained"
                fullWidth
                size="large"
                sx={{
                  textTransform: "capitalize",
                  // size: { lg: "large", md: "large", sm: "medium", xs: "small" },
                  fontSize: { lg: "16px", md: "16px",sm: "10px", xs: "10px" },
                  fontWeight: "600",
                  height: "48px",
                  marginBottom: "24px" ,
                  
                }}
                
              >
                Checkout
              </Button>
            </Box>
          </Box>
    </Box>
  );

  return (
    <div>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer1(anchor, true)}>{anchor}</Button>
          <Drawer
            anchor={anchor}
            open={state1[anchor]}
            onClose={toggleDrawer1(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
